import axios from "axios";
import { config } from "../config";
import { authenticate, createResponseErrorHandler, parseDates, stringifyDates } from "./interceptors";

export const { apiVersion } = config.xola;

export const xolaWaiversApi = axios.create({
    baseURL: config.xolaWaivers.url,
    headers: { "X-API-VERSION": apiVersion },
});

xolaWaiversApi.interceptors.request.use(authenticate);
xolaWaiversApi.interceptors.request.use(stringifyDates);
xolaWaiversApi.interceptors.response.use(parseDates, createResponseErrorHandler(xolaWaiversApi));
